if (!window.hasOwnProperty('coreModules')) {
    window.coreModules = {};
}

window.coreModules.Request = function () {
    var self = this;

    self.ajax = function (options) {
        $.ajax({
            url: options.url || '/',
            data: options.data || {},
            dataType: options.dataType || 'json',
            type: options.type || 'GET',
            async: options.async || true,
        })
            .done(function (response) {
                if ($.isFunction(options.callback)) {
                    options.callback(response);
                }
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                console.log(jqXHR, textStatus, errorThrown);
            });
    };

    self.get = function (url, data, callback, dataType) {
        self.ajax({
            url: url,
            type: 'GET',
            data: !$.isFunction(data) ? data : {},
            callback: $.isFunction(data) ? data : callback,
            dataType: dataType,
        });
    };

    self.post = function (url, data, callback, dataType, async) {
        if ($.isFunction(data)) {
            callback = data;
            data = {};
        }

        self.ajax({
            url: url,
            type: 'POST',
            data: data,
            callback: function (response) {
                callback(response);
            },
            dataType: dataType || 'json',
            async: async || true,
        });
    };

    self.patch = function (url, data, callback, dataType, async) {
        if ($.isFunction(data)) {
            callback = data;
            data = {};
        }

        self.ajax({
            url: url,
            type: 'PATCH',
            data: data,
            callback: function (response) {
                callback(response);
            },
            dataType: dataType || 'json',
            async: async || true,
        });
    };

    self.delete = function (url, data, callback, dataType, async) {
        if ($.isFunction(data)) {
            callback = data;
            data = {};
        }

        self.ajax({
            url: url,
            type: 'DELETE',
            data: data,
            callback: function (response) {
                callback(response);
            },
            dataType: dataType || 'json',
            async: async || true,
        });
    };
};
